export default __webpack_public_path__ + "static/media/logo_full.7db3dd47.png";